var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo/menu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "23.5906059%",
    y1: "88.008125%",
    x2: "79.3721548%",
    y2: "10.6570508%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#467EC0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9AD2",
    offset: "49.1568917%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41C3DE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo/menu",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    opacity: 0,
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,7.5 C12.2101875,7.5 7.5,12.2101875 7.5,18 C7.5,23.7898125 12.2101875,28.5 18,28.5 C23.7898125,28.5 28.5,23.7898125 28.5,18 C28.5,12.2101875 23.7898125,7.5 18,7.5 Z M18,30.75 C10.9696875,30.75 5.25,25.0303125 5.25,18 C5.25,10.9696875 10.9696875,5.25 18,5.25 C25.0303125,5.25 30.75,10.9696875 30.75,18 C30.75,25.0303125 25.0303125,30.75 18,30.75 Z M24.190425,11.5552313 C24.3544875,11.4656063 24.5343,11.6454188 24.444675,11.8094813 L20.729925,18.6200438 C20.4903,19.0595438 19.8953625,19.1452313 19.541175,18.7912313 L17.2088625,16.4587313 C16.854675,16.1047313 16.9403625,15.5097938 17.38005,15.2699813 L24.190425,11.5552313 Z M11.809575,24.4447687 C11.6455125,24.5343937 11.4657,24.3545812 11.555325,24.1905187 L15.270075,17.3799562 C15.5097,16.9404562 16.1046375,16.8547687 16.458825,17.2087687 L18.7911375,19.5412687 C19.145325,19.8952687 19.0596375,20.4902062 18.61995,20.7300187 L11.809575,24.4447687 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "84f9800d28edae6334bc56915d094687.svg";
export { ForwardRef as ReactComponent };